<template lang="pug">
v-app
  //- @ЗАГЛУШКА
  //- .d-flex.justify-center.flex-column.align-center.full-width.full-height
  //-   h1 У нас крупное обновление системы, пока она побудет недоступной.
  //-   h2 Приносим извинения за неудобства.
  dialogs-container
  drawers-container
  welcome-dialog
  mobile-dialog
  user-duplicates-dialog
  cookie-agreement
  support-modal(
    :project-id="$conf.isVcht ? 3 : 2"
  )
  component(:is="layout" v-slot="{ listeners, props }")
    router-view(v-bind="props" v-on="listeners")
</template>

<script>
import { mapActions } from 'vuex';

import Empty from './layouts/empty.vue';
import Remaked from './layouts/remaked.vue';
import Redesign from './layouts/redesign.vue';
import UiDesign from './layouts/ui-design.vue';
import WelcomeDialog from '@/components/dialogs/welcome/WelcomeDialog.vue';
import UserDuplicatesDialog from '@/modules/UserDuplicatesMerges/components/UserDuplicatesDialog.vue';
import CookieAgreement from './components/CookieAgreement.vue';
import SupportModal from '@/components/SupportModal/index.vue';
import MobileDialog from '@/components/dialogs/MobileDialog.vue';

const ACCEPTED_EVERYONE_REDESIGN_NAME_ROUTES = [
  'event-landing-redesign',
  'event-exhibition',
  'exhibition-hall',
  'exhibition-exposition',
  'exhibition-request',
  'exhibition-request-new',
  'exhibition-request-exists',
  'public-expert',
  'public-certificate',
  'public-organization',
  'report',
];

export default {
  components: {
    Empty,
    Remaked,
    Redesign,
    UiDesign,
    WelcomeDialog,
    UserDuplicatesDialog,
    CookieAgreement,
    SupportModal,
    MobileDialog,
  },
  data() {
    return {
      layout: '',
    };
  },
  computed: {},
  watch: {
    $route: {
      handler(value) {
        const { member, expert, trainer, certificate } = this.$conf.ROLES;
        if (
          this.$user.isAuthenticated &&
          this.$user.hasRoles([member, expert, trainer]) &&
          this.isExpiredEmail() &&
          value.path !== '/my-profile' &&
          value.path !== '/verify-email'
        ) {
          this.$router.push({ name: 'profile' });
        }

        this.layout = value.meta.layout || 'remaked';

        if (
          this.layout === 'redesign' &&
          this.$user.isAuthenticated &&
          !this.$user.hasRoles([member, certificate, expert]) &&
          !ACCEPTED_EVERYONE_REDESIGN_NAME_ROUTES.includes(value.name)
        ) {
          this.$router.push('/');
        }
        if (this.layout === 'ui-design' && this.$user.isAuthenticated && !this.$user.isOrganization) {
          this.$router.push('/');
        }
      },
    },
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      init: 'auth/init',
    }),
    isExpiredEmail() {
      if (!this.$user.data.profile || !this.$user.data.profile.email) {
        return false;
      }

      const tempDate = new Date(this.$user.data.created_at);
      tempDate.setDate(tempDate.getDate() + 7);
      return new Date() > tempDate && !this.$user.data.profile.email_verified_at;
    },
  },
};
</script>

<style lang="scss" src="@/styles/scss/index.scss"></style>
